import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-address-list-advt-component',
  templateUrl: './address-list-advt-component.component.html',
  styleUrl: './address-list-advt-component.component.scss'
})

export class AddressListAdvtComponentComponent implements OnInit {

  Address: any;
  flatAddresses: any[] = [];
  pincode: any;
  name: any;
  issuenamenew: any;
  cust_name: any;
  issuedatepp: any;
  val: any;
  advt_name: any;
  rep_name: any;
  off_rep_name: any;
  issue_dates: any;
  issue_date: string;
  issue_name: any;
  today: Date;
  district: any;
  taluka: any;
  start_date: any;
  end_date: any;
  country: any;
  state: any;
  issueDates: any;
  advtType: any;

  constructor(
    private dialogRef: MatDialogRef<AddressListAdvtComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }

  ngOnInit(): void {
    this.issuenamenew = this.data['newissuedatepp'];
    this.cust_name = this.data['cust_name'];
    this.issuedatepp = this.data['issuedatepp'];
    this.start_date = this.data['start_date'];
    this.end_date = this.data['end_date'];
    this.val = this.data['val'];
    this.district = this.data['district'];
    this.country = this.data['country'];
    this.state = this.data['state'];
    this.taluka = this.data['taluka'];
    this.advtType = this.data['advtType'];
    this.issueDates = this.data['issueDates'];

    this.advt_name = this.data['advt_name'] || '';
    this.rep_name = this.data['repname'] || '';
    this.off_rep_name = this.data['offRepName'] || '';

    this.issue_date = this.data['issue_date'] + '';
    if (this.issue_date.includes(',')) {
      [this.issue_date, this.issue_name] = this.issue_date.split(',');
    }
    this.today = new Date();

    this.getAllAddlables(this.val);
  }

  getAllAddlables(val: any) {
    const req = {
      'value': val,
      'issue_name': this.issuenamenew,
      'issue_date': this.issueDates,
      'start_date': this.start_date,
      'end_date': this.end_date,
      'advt_name': this.advt_name,
      'rep_name': this.rep_name,
      'off_rep_name': this.off_rep_name,
      'country': this.country,
      'state': this.state,
      'taluka': this.taluka,
      'district': this.district,
      'advttype': this.advtType,
    };

    console.log(req, "address list req");

    this.service.getAllAddlables(req).subscribe(
      (data: any) => {
        this.Address = data;
        // Flatten into a single array so the table is one row per address
        this.flatAddresses = this.Address.flat();
        console.log("Flattened addresses for list:", this.flatAddresses);
      },
      (error) => {
        console.error("Error fetching addresses:", error);
      }
    );
  }

//   print() {
//     const originalTitle = document.title;
//     document.title = 'पत्ता यादी';

//     const style = document.createElement('style');
//     style.id = 'print-styles';
//     style.innerHTML = `
// @media print {

//   @page {
//     size: A4;
//     margin: 12mm;
//   }

//   body {
//     margin: 0;
//     padding: 0;
//   }

//   .noPrint {
//     display: none !important;
//   }

//   table {
//     width: 100%;
//     border-collapse: collapse;
//   }

//   th, td {
//     border: 1px solid #000;
//     padding: 6px 8px;
//     font-size: 13px;
//   }

//   tr {
//     page-break-inside: avoid;
//   }

//   /* Repeats the header row on every printed page */
//   thead {
//     display: table-header-group;
//   }

// }
// `;

//     document.head.appendChild(style);

//     setTimeout(() => {
//       const printTrigger = document.getElementById('print-button');
//       if (printTrigger) (printTrigger as HTMLElement).click();

//       setTimeout(() => {
//         document.title = originalTitle;
//         const styleElement = document.getElementById('print-styles');
//         if (styleElement) {
//           document.head.removeChild(styleElement);
//         }
//       }, 1000);
//     }, 500);
//   }

  exportexcel(fileName: string): void {
    const data = this.flatAddresses.map(d => ({
      Name: d.name,
      Address: `${d.address}, ${d.taluka}, ${d.district} - ${d.pincode}, ${d.state}`,
      Mobile: d.mobile
    }));

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }


  print() {
  const originalTitle = document.title;
  document.title = 'पत्ता यादी';

  const style = document.createElement('style');
  style.id = 'print-styles';
  style.innerHTML = `
@media print {

  @page {
    size: A4;
    margin: 10mm;
  }

  html, body {
    margin: 0 !important;
    padding: 0 !important;
    width: 210mm !important;
    height: auto !important;
    overflow: visible !important;
    background-color: #ffffff !important;
  }

  .cdk-overlay-pane,
  .mat-dialog-container,
  mat-dialog-content,
  .mat-mdc-dialog-container,
  .mat-mdc-dialog-surface {
    position: static !important;
    width: auto !important;
    height: auto !important;
    max-width: none !important;
    max-height: none !important;
    overflow: visible !important;
    box-shadow: none !important;
    transform: none !important;
  }

  body * {
    visibility: hidden;
  }

  #print-section,
  #print-section * {
    visibility: visible;
  }

  #print-section {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
  }

  .noPrint {
    display: none !important;
  }

  table {
    width: 100% !important;
    table-layout: fixed !important;
    border-collapse: collapse !important;
  }

  table th,
  table td {
    border: 1px solid #000000 !important;
    color: #000000 !important;
    background-color: #ffffff !important;
    font-size: 11px !important;
    padding: 4px 6px !important;
    text-align: left !important;
    box-sizing: border-box !important;
    white-space: normal !important;
    word-break: break-word !important;
    overflow-wrap: anywhere !important;
    overflow: hidden !important;
  }

  thead {
    display: table-header-group;
  }

  tr {
    page-break-inside: avoid;
  }

}
`;

  document.head.appendChild(style);

  setTimeout(() => {
    window.print();

    setTimeout(() => {
      document.title = originalTitle;
      const styleElement = document.getElementById('print-styles');
      if (styleElement) {
        document.head.removeChild(styleElement);
      }
    }, 1000);
  }, 300);
}
 

}
